import { render, staticRenderFns } from "./Journeyplanner.vue?vue&type=template&id=4494e7a0&scoped=true&"
import script from "./Journeyplanner.vue?vue&type=script&lang=js&"
export * from "./Journeyplanner.vue?vue&type=script&lang=js&"
import style0 from "./Journeyplanner.vue?vue&type=style&index=0&id=4494e7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4494e7a0",
  null
  
)

export default component.exports